import React from 'react';
import PropTypes from 'prop-types';
import { includes, map, remove, debounce, isEmpty } from 'lodash';
import validatorHelper from '../helpers/ValidatorHelper';
import i18n from '../i18n';
import baseHelper from '../helpers/BaseHelper';
import { compact } from 'lodash';

class DropdownCheckboxSearch extends React.Component {
    static propTypes = {
        id: PropTypes.string,
        data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        onSelectItem: PropTypes.func,
        handleSearchValue: PropTypes.func,
        currentKey: PropTypes.any,
        currentValue: PropTypes.any,
        _key: PropTypes.string,
        _value: PropTypes.string,
        validations: PropTypes.shape({
            isRequired: PropTypes.bool,
        }),
        placeHolder: PropTypes.string,
        renderItem: PropTypes.func,
        wrapperStyle: PropTypes.object,
        buttonStyle: PropTypes.object,
        wrapperClassName: PropTypes.string,
        inputClassName: PropTypes.string,
        idBlock: PropTypes.string
    };

    static defaultProps = {
        _key: 'code',
        _value: 'name',
        validations: {
            isRequired: false,
        },
    };

    constructor(props) {
        super(props);

        this.state = {
            searchInput: '',
            disabled: props.disabled,
            selectedItems: props.selectedItems ? props.selectedItems : [],
            selectedNames: '',
            // visibleData: props.data,
            datas: props.data,
        };
        this.selectedItems = props.selectedItems ? props.selectedItems : [];

        this.ref = React.createRef();
        this.inputRef = React.createRef();

        this.reset = this.reset.bind(this);
        this.autoSearch = debounce(this.search, 500);
    }

    // eslint-disable-next-line camelcase
    async UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props === nextProps) {
            return;
        }

        if (this.props.data != nextProps.data) {
            await this.setState({
                datas: nextProps.data,
            });
        }

        const { datas } = this.state;
        let { selectedItems } = this;
        let selectedNames = '';

        // for (let i = 0; i < datas.length; i++) if (includes(selectedItems, datas[i].value)) selectedNames += ` ${datas[i].name},`;
        for (let i = 0; i < datas.length; i++) {
            let isExit = selectedItems.some((item) => item.custom_field_id == datas[i].custom_field_id);
            if (isExit) {
                selectedNames += `${datas[i].name},`;
            }
        }

        selectedNames = selectedNames.substring(',', selectedNames.length - 1);
        if (!isEmpty(selectedNames))
            this.setState({
                selectedNames,
            });

        if (this.props.selectedItems != nextProps.selectedItems) {
            this.setState({
                selectedItems: nextProps.selectedItems || [],
            });
            this.selectedItems = nextProps.selectedItems || [];
        }
    }

    componentDidMount() {
        this.init(this.props);
    }

    init = (props) => {
        const { data } = props;
        const { selectedItems } = this;
        let selectedNames = '';
        // for (let i = 0; i < data.length; i++) if (includes(selectedItems, data[i].value)) selectedNames += ` ${data[i].name},`;
        for (let i = 0; i < data.length; i++) {
            let isExit = selectedItems.some((item) => item.custom_field_id == data[i].custom_field_id);
            if (isExit) {
                selectedNames += `${data[i].name},`;
            }
        }
        selectedNames = selectedNames.substring(',', selectedNames.length - 1);
        if (!isEmpty(selectedNames))
            this.setState({
                selectedNames,
            });
        this.setState({
            data,
            selectedItems: props.selectedItems ? props.selectedItems : [],
        });
        this.selectedItems = props.selectedItems ? props.selectedItems : [];
    };

    getValueByKey = (_key) => {
        let matchedItem = {};
        map(this.state.datas, (item) => {
            if (item[this.props._key] === _key) {
                matchedItem = item;
            }
        });
        return matchedItem[this.props._value];
    };

    onChangeSearchInput = (event) => {
        const { value } = event.target;

        // let visibleData = map(this.props.data, (item) => {
        //     if (baseHelper.getAliasName(item[this.props._key]).indexOf(baseHelper.getAliasName(value)) > -1) {
        //         return item;
        //     }
        // });

        // visibleData = compact(visibleData);

        this.setState({
            searchInput: value,
            // datas: visibleData,
        });
    };

    search = () => {
        const { searchInput } = this.state;
        this.props.handleSearchValue(searchInput);
    };

    onSelectItem = (selected) => {
        if ((!selected && !this.props.currentKey) || (selected && selected[this.props._key] === this.props.currentKey)) {
            return;
        }
        this.props.onSelectItem(selected);

        this.reset();
    };

    validate = () => {
        const errors = [];
        if (!this.ref.current) {
            return errors;
        }

        const { classList } = this.inputRef.current;
        classList.remove('error');

        let validateStatus = true;

        const { currentKey, validationName } = this.props;

        const { isRequired } = this.props.validations;
        if (isRequired) {
            if (validatorHelper.isEmpty(currentKey)) {
                validateStatus = false;
                errors.push(i18n.t('VALIDATION.ENTER', validationName));
            }
        }

        if (!validateStatus) {
            classList.add('error');
        }

        return errors;
    };

    onKeyDownInputSearch = (event) => {
        if (event.key == "Enter") {
            this.search();
        }
    }

    renderItems = () => {
        const { _key, data, idBlock } = this.props;
        const { selectedItems, datas } = this.state;

        const items = map(datas, (item, index) => (
            <li className='ladiui check-element' key={index}>
                <label className='ladiui search-checkbox default-text flex' data-id={index}>
                    <input
                        name='checkbox'
                        type='checkbox'
                        className='ladiui checkbox size-checkbox form-check-input-checkbox mr-8'
                        onChange={(event) => this.checkItem(event, item)}
                        // checked={selectedItems.indexOf(item.value) >= 0}
                        checked={selectedItems.some((_item) => _item.custom_field_id == item.custom_field_id)}
                    />
                    <p style={{ fontWeight: item.level == 1 ? 500 : '', marginLeft: item.level == 1 ? '16px' : '' }}>
                        {item[_key] || item}
                    </p>
                </label>
            </li>
        ));

        return items;
    };

    reset() {
        this.setState({
            searchInput: '',
        });
    }

    // checkAllItem = (event) => {
    //     const { checked } = event.target;
    //     const { datas } = this.state;
    //     this.selectedItems = [];
    //     if (checked) {
    //         this.selectedItems = map(datas, (tag) => tag.value);
    //     }

    //     let selectedNames = '';

    //     for (let i = 0; i < datas.length; i++) {
    //         if (includes(this.selectedItems, datas[i].value)) {
    //             selectedNames += `${datas[i].name},`;
    //         }
    //     }
    //     selectedNames = selectedNames.substring(',', selectedNames.length - 1);

    //     this.setState(
    //         {
    //             selectedItems: this.selectedItems,
    //             selectedNames,
    //         },
    //         () => {
    //             this.onSubmit();
    //         }
    //     );
    // };
    checkItem = async (event, item) => {
        const { checked } = event.target;
        let { selectedItems } = this;
        // let _selectedItem = this.selectedItems;
        let { datas } = this.state;

        if (checked) {
            // if (!includes(selectedItems, item.value)) {
            let isExit = selectedItems.some((_item) => _item.custom_field_id == item.custom_field_id);

            if (!isExit) {
                // selectedItems.push(item.value);
                selectedItems.push(item);
            }
        } else {

            // remove(selectedItems, (selectedID) => selectedID === item.value);
            remove(selectedItems, (_item) => _item.custom_field_id === item.custom_field_id);
        }
        let selectedNames = '';

        for (let i = 0; i < datas.length; i++) {
            // if (includes(selectedItems, datas[i].value)) {
            //     selectedNames += `${datas[i].name},`;
            // }
            if (selectedItems.some((_item) => _item.custom_field_id == datas[i].custom_field_id)) {
                selectedNames += `${datas[i].name},`;
            }
        }

        selectedNames = selectedNames.substring(',', selectedNames.length - 1);
        await this.setState(
            {
                selectedItems,
                selectedNames,
            }
        );

        this.onSubmit();
    };

    openItem = () => {
        this.setState({
            openItem: true,
        });
    };

    closeItem = () => {
        this.setState({
            openItem: false,
        });
        this.props.onSubmit(this.state.selectedItems);
    };

    onSubmit = () => {
        // if (this.props.data.length > 0) {
        this.props.onSubmit(this.state.selectedItems);
        // }
    };

    render() {
        const {
            id,
            currentKey,
            currentValue,
            placeHolder,
            wrapperStyle,
            wrapperClassName,
            buttonStyle,
            inputClassName,
            innerClassName,
            disabled,
            pickTitle,
            styleCustomPeople,
            data,
            isLoading,
            isCreateCategory,
            isShowBlockInputSearch,
            idBlock,
            renderHeaders
        } = this.props;
        const { searchInput, openItem, selectedNames, selectedItems, datas } = this.state;
        let displayData = '';
        if (isEmpty(selectedNames)) {
            displayData = currentValue || this.getValueByKey(currentKey) || placeHolder;
        } else {
            displayData = selectedNames;
        }
        return (
            <div className={`ladiui select-search dropdown ${innerClassName}`} id='dropdown-staff'>
                <button className='ladiui btn btn-outline-light dropdown-toggle relative' data-toggle='dropdown' style={buttonStyle}>
                    <i></i>
                    <span className='ladiui dropdown-text' data-text={displayData}>
                        {displayData}
                    </span>
                </button>
                <ul id={idBlock} className={`ladiui dropdown-menu custom-people field`} style={styleCustomPeople}>
                    {isShowBlockInputSearch && (
                        <div className='ladiui form-group dropdown-input-search-custom mb-16'>
                            <i className='ladi-icon ldicon-search' onClick={() => this.search()} />
                            <input
                                type='text'
                                className='ladiui form-control'
                                name='searchInput'
                                value={this.state.searchInput}
                                placeholder='Tìm kiếm...'
                                onChange={(e) => this.onChangeSearchInput(e)}
                                onKeyDown={this.onKeyDownInputSearch}
                            />
                        </div>
                    )}

                    {
                        renderHeaders && renderHeaders()
                    }
                    {/* <li className='ladiui check-element' key={-1}>
                        <label className='ladiui search-checkbox default-text flex' data-id={-1}>
                            <input
                                name='checkbox'
                                type='checkbox'
                                className='ladiui checkbox size-checkbox form-check-input-checkbox'
                                onChange={(event) => this.checkAllItem(event)}
                                checked={selectedItems.length === datas.length}
                            />
                            {'Chọn tất cả'}
                        </label>
                    </li> */}
                    {this.renderItems()}
                </ul>
            </div>
        );
    }
}

export default DropdownCheckboxSearch;
